module.exports = __webpack_public_path__ + "static/media/SareeCloset2016.60d175dd.jpg";